/**
 * The gender radio stores the *translated display label*.
 */

export type CanonicalGender = "MALE" | "FEMALE";

/** Uppercase and strip diacritics so the German label matches its ASCII form. */
function normalizeLabel(value: string): string {
  return value.normalize("NFD").replace(/[̀-ͯ]/g, "").trim().toUpperCase();
}

// Labels are listed already normalized (uppercase, no diacritics).
const MALE_LABELS = [
  "MALE", // en
  "MASCHIO", // it
  "HOMME", // fr
  "MASCULINO", // es
  "MANNLICH", // de
  "M",
];

const FEMALE_LABELS = [
  "FEMALE", // en
  "FEMMINA", // it
  "FEMME", // fr
  "FEMININA", // es
  "WEIBLICH", // de
  "F",
];

export function normalizeGender(value: unknown): CanonicalGender | "" {
  if (typeof value !== "string" || value.trim() === "") return "";
  const normalized = normalizeLabel(value);
  if (MALE_LABELS.includes(normalized)) return "MALE";
  if (FEMALE_LABELS.includes(normalized)) return "FEMALE";
  return "";
}
